import React, { useEffect, useState } from "react";
import TouristAppointmentsApi from "../../../services/TouristAppointmentsApi";
import {
    Drawer,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery
} from "@mui/material";
import { Link } from "react-router-dom";
import { ModeEditOutlineSharp } from "@mui/icons-material";
import { EditActivities } from "./editActivities";
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from "react-bootstrap";

export default function AllActivities() {
    const { getActivities } = TouristAppointmentsApi();
    const [activity, setActivity] = useState(null);
    const [show, setShow] = useState(false);
    const [activeModal, setActiveModal] = useState();
    const [activityId, setActivityId] = useState('');
    const isMobile = useMediaQuery('(max-width:  768px)')

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        getActivities()
            .then((res) => {
                setActivity(res)
            })
    }

    const renderModalContent = () => {
        switch (activeModal) {
            case 'editactivity':
                return <EditActivities
                    // doctorId={doctorId}
                    activityId={activityId}
                    onSubmit={handleEditClose} />
            default:
                return null;
        }
    };

    const getDrawerTitle = () => {
        switch (activeModal) {
            case 'editactivity':
                return 'Edit Activity';
            default:
                return '';
        }
    };

    const handleEdit = (item) => {
        setActivityId(item)
        setShow(true)
    }
    const handleEditClose = (item) => {
        setShow(false)
    }
    const openDrawerWithModal = (modalType, item) => {
        setActiveModal(modalType);
        // setViewInwardData(item)
        // setDrawerOpen(true);
        setShow(true)
    };
    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className="font_weight" align="left">Serial No</TableCell>
                            <TableCell className="font_weight" align="left">Activity Name</TableCell>
                            <TableCell className="font_weight" align="left">Activity Details</TableCell>
                            <TableCell className="font_weight" align="left">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {activity && activity.map((item, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell align="left">
                                        {index + 1}
                                    </TableCell>

                                    <TableCell align="left">
                                        {item.activity_name}
                                    </TableCell>

                                    <TableCell align="left">
                                        {item['activity_details'].map((res, index) => (
                                            <div key={index}>{res}</div>
                                        ))}
                                    </TableCell>

                                    <TableCell align="left">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Link sx={{ fontSize: { xs: 15, sm: 18 } }} onClick={() => isMobile ? openDrawerWithModal('editactivity', item._id) : handleEdit(item._id)}>
                                                <ModeEditOutlineSharp style={{ marginLeft: 15, fontSize: 20 }} />
                                            </Link>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {isMobile ? (
                <Drawer anchor="bottom" open={show} onClose={handleEditClose}>
                    <div className='drawerTitle underline' >
                        <Typography variant="h6">
                            {getDrawerTitle()}
                        </Typography>
                        <IconButton onClick={handleEditClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className='p-4'>
                        {renderModalContent()}
                    </div>
                </Drawer>
            ) : (
                <>
                    <div className="modalbtn">
                        <Modal show={show} onHide={handleEditClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Edit Activity</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <EditActivities
                                    activityId={activityId}
                                    // doctorId={doctorId}
                                    onSubmit={handleEditClose} 
                                />
                            </Modal.Body>
                        </Modal>
                    </div>
                </>
            )}
        </>
    )
}